import React, { useState, useContext, useEffect } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const DoSOverTimeStatsHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);

  const doClose = () => setOpen(false);

  useEffect(() => {
    return actions.recv("open-help", function () {
      setOpen(true);
    });
  }, []);
  return open !== true ? null : (
    <Modal
      title="DoS ATTACKS OVER TIME"
      onClose={doClose}
      content={() => (
        <>
         <p>Denial-of-Service (DoS) attacks detected over time, classified by the type of DoS attack.</p>
        <ul>
          <li><b>Volume</b>: Volumetric DoS attacks, where a subscriber received data at a speed larger than the threshold (configured as "Threshold for downlink volume attack" in the Subscriber Rate policy). This would be cases where a network subscriber is receiving an attack.</li>
          <li><b>Syn-Rcv</b>: TCP SYN flood attack, where a subscriber (an IP address in the access side) received more failed handshake SYNs than the threshold (configured as "Failed handshake ingress rate" in the Subscriber Rate policy). This would be cases where a network subscriber is receiving an attack.</li>
          <li><b>Syn-Snt</b>: TCP SYN flood attack, where a subscriber (an IP address in the access side) emitted more failed handshake SYNs than the threshold (configured as "Failed handshake egress rate" in the Subscriber Rate policy). This would be cases where a network subscriber is attacking other IP addresses.</li>
        </ul>
        <p>Chart selectors:</p>
        <ul>
          <li><i class="material-icons valign-icon">date_range</i> Selects the range of time values shown starting from now: 1 day, 1 week or 1 month. The slider at the bottom of the graph allows refining the range of date values shown: a shorter interval by dragging any of the dated labels and, once done, by dragging the central part</li>
        </ul>
        <p>Click on the coloured dots on top-right corner of the graph to optionally select and de-select which types of attacks are shown.</p>
        <p>Double-click on the coloured dots on top-right corner of the graph to optionally isolate the selected type of attacks.</p>
        <p>Click on the <i class="material-icons valign-icon">refresh</i> icon to refresh the data.</p>
        </>
      )}
    />
  );
};
export default DoSOverTimeStatsHelpModal;
